import React from 'react';
import Icon from './Icon';

const CrosshairIcon = (props) => (
    <Icon {...props}>
        <path
            d="M18 12A6 6 0 1 1 6 12A6 6 0 0 1 18 12M12 2V5M12 19V22M2 12H5M19 12H22M12 12H12.01"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default CrosshairIcon;